import React, { useCallback, useEffect, useState } from "react";
import Header from "./Header";
import Menus from "./Menus";
import { useSelector } from "react-redux";
import { isSet } from "../../../utils/commonUtils";
import { activeProfileDetails } from "../../../store/SessionSlice";
import SessionTimeout from "../../../hoc/SessionTimeout";
import PERMISSIONS from "../../../utils/AclPermissions";
import { useDispatch } from "react-redux";
import { clearCbState } from "../../../store/GlobalFilterSlice";
import NotificationMessage from "./NotificationMessage";
import { fetchNotificationStatus, fetchRxntPendingNotificationCount } from "../../../store/NotificationSlice";
import { isUserbillingModuleElabled } from "../../../utils/aclUtils";

const AppLayout = (props) => {
  const { children } = props;
  const [activeMenu, setActiveMenu] = useState('');
  const [mainMenusList,setMainMenusList]  = useState([]);
  const [configMenusList,setConfigMenusList] = useState([]);
  const dispatch = useDispatch();
  const [showNotification,setShowNotification]=useState(false);    
  let currentPath = window.location.pathname;
  
 
  const profileDetails = useSelector(activeProfileDetails);
  const reloadId = useSelector(state=>state.common.reloadKeyProps);
  useEffect(()=>{
    let MenusData = [];
    let Configures = [];
    if (isSet(profileDetails?.role,'') === "global_admin" || isSet(profileDetails?.is_multiple_organization,'') === true) {
      MenusData = [
        {
          title: "Organization",
          link: "/organisation",
          acl: ['organization-list'],
          iconType: "organization",
        },
        {
          title: "Organization Companies",
          link: "/company",
          acl: ['company-list'],
          iconType: "Company",
        },
        // {
        //   title: "Labs",
        //   link: "/labs",
        //   acl: ['result-list'],
        //   iconType: "Labs",
        // },
        // {
        //   title: "Results",
        //   // link: "/result/physical-drug-screens",
        //   acl: ['result-list'],
        //   iconType: "Results",
        //   attr:{
        //     'data-bs-toggle':"collapse",
        //     'data-bs-target':'#results-submenu1'
        //   },
        //   subMenuId:'results-submenu1',
        //   subMenu:[
        //     {
        //       title: "Vaccines",
        //       link: "/result/vaccine",
        //       acl: ['result-list'],
        //       iconType: "PatientChart",
        //     },
        //     {
        //       title: "Physicals & Drug Screens",
        //       link: "/result/physical-drug-screens",
        //       acl: ['result-list'],
        //       iconType: "PatientChart",
        //     },
        // ],
        // },
        {
          title: "Organization Chart",
          link: "/employee",
          acl: ['employee-list'],
          iconType: "PatientChart",
        },
      ];
      Configures = [
        { Title: "Users", link: "/users", acl: 'user-list' },
        { Title: "Role & Permissions", link: "/roles", acl: 'role-list' },
        { Title: "Clinics", link: "/clinics", acl: 'clinic-list' },
        { Title: "Providers", link: "/providers", acl: 'provider-list' },
         { Title: "Referral Providers", link: "/referral-providers", acl: 'referral-provider-list' },
        { Title: "Laboratory", link: "/laboratory", acl: 'lab-list' },
        { Title: "Clinic Department", link: '/clincs-department', acl: 'clinic-department-list' },
        { Title: "Insurance", link: '/insurance', acl: 'insurance-list' },
        { Title: "Work Comp Insurance", link: '/workcomp-insurance', acl: [PERMISSIONS.WORK_COMP_INSURANCE.LIST] },
        { Title: "Company Divisions", link: "/division", acl: ['company-division-list'] },
        { Title: "Lookup", link: "/lookup", acl: ['lookup-list'] },
        { Title: "Basic Physical", link: "/basic-physical", acl: ['basic-physical-list'] },
        { Title: "Activities", link: "/activities", acl: ['activities-list'] },
        { Title: "Compliance Monitor", link: "/compliance-monitor", acl: [PERMISSIONS.COMPLIANCE_MONITOR.LIST] },
        { Title: "Contract Pricing", link: "/contract/pricing", acl: ['activities-list'] },
        { Title: "CPT Code", link: "/cpt-code", acl: [PERMISSIONS.CPT.LIST] },
        { Title: "ICD-10 Code", link: "/icd10-code", acl:  [PERMISSIONS.ICD10.LIST]  },
        { Title: "Intake Paperwork", link: "/intake-paperwork", acl: ['consent-list'] },
        { Title: "Vaccine Administration", link: "/vaccine-administration", acl: ['vaccine-administration-list'] },
        { Title: "SFTP Configuration", link: "/configure", acl: [PERMISSIONS.SFTP_CONFIGURATION.LIST] },
        { Title: "CSV Imports", link: "/csv-import", acl: [PERMISSIONS.CSV_IMPORT.LIST] },
        { Title: "Failed EZ-Reader", link: "/failed-ez-reader", acl:[PERMISSIONS.FAILED_EZ_READER.LIST] },
        { Title: "Notification Log", link: "/notification-log", acl: [PERMISSIONS.NOTIFICATION_LOG.LIST] },
        { Title: "HL7 Log", link: "/hl7/log", acl: [PERMISSIONS.HL7_LOG.LIST] },
        { Title: "Audit Log", link: "/audit-log", acl: [PERMISSIONS.AUDIT_LOG.LIST] },
        { Title: "AI Diagnosis Logs", link: "/ai-diagnosis-logs", acl: [PERMISSIONS.AI_DIAGNOSIS_LOGS.LIST] },
        { Title: "DOT Submission Logs", link: "/dot-submission-logs", acl: [PERMISSIONS.DOT_SUBMISSION_LOGS.LIST] },
        { Title: "EMR Fields Setup", link: "/emr" ,acl:[PERMISSIONS.EMR_CONFIGURATION.LIST]  },
        { Title: "Random Generator", link: "/random-generator" ,acl:[PERMISSIONS.RANDOM_GENERATOR.LIST]  },
        { Title: "State Forms Configuration", link: "/forms-configuration" ,acl:[PERMISSIONS.STATE_FORMS.LIST]},
        { Title: "Lab Panel Configuration", link: "/lab-pannel-configuration", acl:[PERMISSIONS.LAB_PANEL.LIST]  },
        { Title: "Lab Panel Manual Import", link: "/lab-pannel-import", acl:[PERMISSIONS.LAB_PANEL.LIST]   },
        { Title: "Tutorial Video Configure", link: "/video-configure", acl: [PERMISSIONS.TUTORIAL_VIDEO.LIST] },
        { Title: "Notification Template", link: "/notification-template", acl: [PERMISSIONS.NOTIFICATION_TEMPLATE.LIST] },
       

      ];
    }else {
      MenusData = [
        {
          title: "Dashboard",
          link: "/dashboard",
          acl: [PERMISSIONS.DASHBOARD.LIST] ,
          iconType: "DashboardIcon",
        },
        // {
        //   title: "Companies",
        //   link: "/company",
        //   acl: ['company-list'],
        //   iconType: "Company",
        // },
        {
          title: "Appointments",
          link: "/appointments",
          acl: profileDetails?.employer_login === true ? ['appointment-list'] : ['appointment-list', 'employee-list'],
          iconType: "Schedule",
        },
        {
          title: "White Board",
          link: "/white-board",
          acl: ['white-board-list'],
          iconType: "WhiteBoard",
        },
        {
          title: "Visits",
          link: "/visits",
          acl: ['visits-list'],
          iconType: "PatientVisit",
        },
        {
          title: "Results",
          // link: "/result/physical-drug-screens",
          acl: ['result-list'],
          iconType: "Results",
          attr:{
            'data-bs-toggle':"collapse",
            'data-bs-target':'#results-submenu'
          },
          subMenuId:'results-submenu',
          subMenu:[
            {
              title: "Labs",
              link: "/labs",
              acl: ['result-list'],
              iconType: "Labs",
            },
            {
              title: "Vaccines",
              link: "/result/vaccine",
              acl: ['result-list'],
              iconType: "PatientChart",
            },
            {
              title: "Physicals & Drug Screens",
              link: "/result/physical-drug-screens",
              acl: ['result-list'],
              iconType: "PatientChart",
            },
            {
              title: "Work Status",
              link: "/result/workstatus",
              acl: [PERMISSIONS.WORK_STATUS.LIST],
              iconType: "WorkStatus", 
            },
            {
              title: "RXNT Prescriptions",
              link: "/result/rxnt-prescriptions",
              acl: ['result-list'],
              iconType: "Results",
            }
        ],
          
        },
        {
          title: "Patients",
          link: "/employee",
          acl: ['employee-list'],
          iconType: "PatientChart",
        },
        // {
        //   title: "Biller Report",
        //   // link: "/result/physical-drug-screens",
        //   acl: ['result-list'],
        //   iconType: "Results",
        //   attr:{
        //     'data-bs-toggle':"collapse",
        //     'data-bs-target':'#reports-submenu'
        //   },
        //   subMenuId:'reports-submenu',
        //   subMenu:[
        //     {
        //       title: "Lab Report",
        //       link: "/reports",
        //       acl: ['result-list'],
        //     },
        //     {
        //       title: "Diagnosis Report",
        //       link: "/reports",
        //       acl: ['result-list'],
        //     },
        // ],
          
        // },
        {
          title: "Billing",
          link: `${process.env.REACT_APP_COLLECTOR_URL}/login/healthcare?user_id=${profileDetails.id}`,
          // link:`https://snapcollector.com`,
          acl:isUserbillingModuleElabled(profileDetails) ? 'any':'',
          iconType: "Billing",
        },
        {
          title: "Reports",
          link: "/reports",
          acl: [PERMISSIONS.REPORTS.LIST],
          iconType: "Reports",
        },
         {
          title: "Incident",
          link: "/incident",
          acl: [PERMISSIONS.INCIDENT.LIST],
          iconType: "Incident",
        },
      ];
      Configures = [
        { Title: "Companies", link: "/company", acl: ['company-list'] },
        { Title: "Users", link: "/users", acl: 'user-list' },
        { Title: "Role & Permissions", link: "/roles", acl: 'role-list' },
        { Title: "Clinics", link: "/clinics", acl: 'clinic-list' },
        { Title: "Providers", link: "/providers", acl: 'provider-list' },
         { Title: "Referral Providers", link: "/referral-providers", acl: 'referral-provider-list' },
        { Title: "Laboratory", link: "/laboratory", acl: 'lab-list' },
        { Title: "Clinic Department", link: '/clincs-department', acl: 'clinic-department-list' },
        { Title: "Insurance", link: '/insurance', acl: 'insurance-list' },
        { Title: "Company Divisions", link: "/division", acl: ['company-division-list'] },
        { Title: "Lookup", link: "/lookup", acl: ['lookup-list'] },
        { Title: "Basic Physical", link: "/basic-physical", acl: ['basic-physical-list'] },
        { Title: "Activities", link: "/activities", acl: ['activities-list'] },
        { Title: "Compliance Monitor", link: "/compliance-monitor", acl: [PERMISSIONS.COMPLIANCE_MONITOR.LIST] },
        { Title: "Contract Pricing", link: "/contract/pricing", acl: ['activities-list'] },
        // { Title: "Contract Approvals", link: "/contract/approval", acl: ['activities-list'] },
        { Title: "Intake Paperwork", link: "/intake-paperwork", acl: ['consent-list'] },
        { Title: "Vaccine Administration", link: "/vaccine-administration", acl: ['vaccine-administration-list'] },
        { Title: "CSV Imports", link: "/csv-import", acl: [PERMISSIONS.CSV_IMPORT.LIST] },
        { Title: "Import Historical Visit", link: "/historical-visit-import", acl: [PERMISSIONS.HISTORICAL_VISIT.LIST, PERMISSIONS.CSV_IMPORT.LIST] },
        { Title: "Failed EZ-Reader", link: "/failed-ez-reader", acl: [PERMISSIONS.FAILED_EZ_READER.LIST] }, 
        { Title: "Notification Log", link: "/notification-log", acl: [PERMISSIONS.NOTIFICATION_LOG.LIST] },
        { Title: "HL7 Log", link: "/hl7/log", acl:  [PERMISSIONS.HL7_LOG.LIST] },
        { Title: "EMR Fields Setup", link: "/emr", acl:[PERMISSIONS.EMR_CONFIGURATION.LIST]  },
        { Title: "Random Generator", link: "/random-generator" ,acl:[PERMISSIONS.RANDOM_GENERATOR.LIST]},  
        { Title: "Scheduled Patients", link: "/random-scheduled-patients", acl:[PERMISSIONS.VISIT_SCHEDULE.LIST]},
        { Title: "State Forms Configuration", link: "/forms-configuration" ,acl:[PERMISSIONS.STATE_FORMS.LIST]},
        { Title: "Lab Panel Configuration", link: "/lab-pannel-configuration", acl:[PERMISSIONS.LAB_PANEL.LIST] },
        { Title: "Lab Panel Manual Import", link: "/lab-pannel-import", acl:[PERMISSIONS.LAB_PANEL.LIST] },
      ];
    } 
    // else if(isSet(profileDetails) && isSet(profileDetails?.role[0],'') === "company_employee"  && isSet(profileDetails?.is_multiple_organization,false) === false) {
    //   MenusData = [
        
    //     {
    //       title: "Appointments",
    //       link: "/appointments",
    //       acl: ['appointment-list', 'employee-list'],
    //       iconType: "Schedule",
    //     },
    //     {
    //       title: "Labs",
    //       link: "/labs",
    //       acl: ['result-list'],
    //       iconType: "Labs",
    //     },
    //     {
    //       title: "Results",
    //       acl: ['result-list'],
    //       iconType: "Results",
    //       attr:{
    //         'data-bs-toggle':"collapse",
    //         'data-bs-target':'#results-submenu'
    //       },
    //       subMenuId:'results-submenu',
    //       subMenu:[
    //         {
    //           title: "Vaccines",
    //           link: "/result/vaccine",
    //           acl: ['result-list'],
    //           iconType: "PatientChart",
    //         },
    //         {
    //           title: "Physicals & Drug Screens",
    //           link: "/result/physical-drug-screens",
    //           acl: ['result-list'],
    //           iconType: "PatientChart",
    //         },
    //       ],
          
    //     },
    //   ];
    //   Configures = [];
      
    // }
    setMainMenusList(MenusData)
    setConfigMenusList(Configures);
  },[profileDetails])
  
  useEffect(() => {
    const currentPath = window.location.pathname;
    let matchingMenu = mainMenusList.find(menu => 
      isSet(menu?.subMenu,false)==false 
        ? currentPath.startsWith(menu.link)
        : menu.subMenu.find(sub=>currentPath.startsWith(sub.link)) 
    );
    if (matchingMenu) {
      setActiveMenu(matchingMenu.title);
    } else {
      matchingMenu = configMenusList.find(menu => currentPath.startsWith(menu.link));
      if (matchingMenu) {
        setActiveMenu(matchingMenu.Title);
      }
    }
  }, [mainMenusList, configMenusList]);
  useEffect(()=>{    
    let matchingMenu = mainMenusList.find(menu => currentPath.startsWith(menu.link));
    if (matchingMenu) {
      setActiveMenu(matchingMenu.title);
    } else {
      matchingMenu = configMenusList.find(menu => currentPath.startsWith(menu.link));
      if (matchingMenu) {
        setActiveMenu(matchingMenu.Title);
      }
    }
  },[currentPath]);  
  const sideBarChangeHandler = useCallback(() => {
    if (document.body.classList.contains('show-sidebar')) {
      document.body.classList.remove('show-sidebar');
      // menuToggleElement.removeClass('active');
    } else {
      document.body.classList.add('show-sidebar');
    }
  }, []);

  useEffect(()=>{
    if (document.body.classList.contains('show-sidebar')) {
      document.body.classList.remove('show-sidebar');
    } 
    dispatch(clearCbState());
  },[activeMenu])

  const removeSideBar=()=>{
    // document.body.classList.remove('show-sidebar');
  };

  

  useEffect(() => {
    const handleMouseUp = (e) => {
      const container = document.querySelector(".sidebar");
      const linkElement = document.querySelector(".js-menu-toggle");

      // Check if the clicked element is the link
      if (!container.contains(e.target) && isSet(linkElement) && !linkElement.contains(e.target)) {
        if (document.body.classList.contains('show-sidebar')) {
          document.body.classList.remove('show-sidebar');
          // Optionally, you can uncomment the line below if you have a menuToggleElement.
          // menuToggleElement.classList.remove('active');
        }
      }
    };

    document.addEventListener('mouseup', handleMouseUp);
    
    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    
  }, []);

 useEffect(()=>{
  document.title = 'Snap HealthCare | '+isSet(activeMenu,'Home');
  dispatch(fetchNotificationStatus());
  dispatch(fetchRxntPendingNotificationCount());
 },[activeMenu, dispatch]);

 const notificationToogleHandler=()=>{
  setShowNotification(!showNotification)
 }

  useEffect(() => {
    if (showNotification) {
      dispatch(fetchRxntPendingNotificationCount());
    }
  }, [showNotification, dispatch]);

  return (
    <>
    <SessionTimeout timeout={process.env.REACT_APP_SESSION_TIMEOUT} />
    <div className={""}>
      <div id="wrapper">
        <Menus
          MenusData={mainMenusList}
          Configures={configMenusList}
          setActiveMenu={setActiveMenu}
          currentPath={currentPath}
          activeMenu={activeMenu}
          sideBarChangeHandler={sideBarChangeHandler}
          removeSideBar={removeSideBar}
        />
        <div id="content-wrapper" className="d-flex flex-column">
          {/* <!-- Main Content --> */}
          <div id="content">
            <Header activeMenu={activeMenu} notificationToogleHandler={notificationToogleHandler}/>
            <div className="container-fluid">
              <div className="sh_mainPortview" id="sh_mainportal_view">
                <div className="sh_innerPortview" key={reloadId}>
                  {
                    showNotification?
                    <NotificationMessage
                    modleToogleHandler={notificationToogleHandler}
                    />
                    :
                    <></>
                  }
                 
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};


export default (AppLayout);
